/*
THIS COMPONENT INCLUDING IN WAREHOUSE INCOMING PAGES
 ---------------------------------------------*/
import('jquery-ui');

let WarehouseAutocompleteForm = {

    cache: {},
    term: '',
    formContainer: $('#warehouse_autocomplete_form'),
    searchContainer: $("#warehouse_autocomplete_search"),
    minLength: 3,
    delay: 300,
    action: '',

    focus: function(element) {
        var focusedElement = this.getSelectedProductRow(element).find('input.form-control.input-sm:first');
        focusedElement.focus();
        this.scrollToFocusedElement(focusedElement);
    },
    getSelectedItemId: function() {
        return this.searchContainer.data('selected-item');
    },
    setValueToInput: function(ui) {
        this.searchContainer.val(ui.item.name).data("selected-item", ui.item.id);
        this.cleanSelectedClass();
    },
    getSelectedProductRow : function(element) {
        return element.parents('tr').addClass('finded-product');
    },
    cleanSelectedClass : function() {
        this.formContainer.find('tr').removeClass('finded-product');
    },
    getSelectedProduct: function(item) {
        let selectedProduct = this.formContainer.find("[data-product='" + item + "']");

        if (selectedProduct.length > 0) {
            return selectedProduct;
        }

        WarehouseAutocompleteForm.loadBrandByProductId(item);
        return this.formContainer.find("[data-product='" + item + "']");
    },
    loadBrandByProductId: function (productId) {
        $.ajax({
            type: 'POST',
            url: '/warehouse/' + WarehouseAutocompleteForm.action + '/load_brand',
            data: {productId: productId},
            dataType: 'json',
            async: false,
            success : function (response) {
                var container = $('#products-table-' + response.brandId);
                container.html(response.html);
            }
        });
    },
    openProductPanel: function(element) {
        let panelHeader = element.parents('div.panel.panel-default').find('.panel-heading a');

        if(panelHeader.hasClass('collapsed'))  {
            panelHeader.click();
        }
    },
    replaceText: function(original, searchString) {
        return String(original).replace(
            new RegExp(searchString, "gi"),
            "<b class='ui-state-highlight'>$&</b>"
        );
    },
    setAutocompleResult: function(ul, item, newText) {
        return $('<li class="b-warehouse-autocomplete-result__item"></li>')
            .data("ui-autocomplete-item", item)
            .append("<a>" + newText + "</a>")
            .appendTo(ul)
    },
    ajaxJson: function(request, response) {
        this.term = request.term;
        if ( this.term in this.cache ) {
            response( this.cache[ this.term ] );
            return;
        }
        $.getJSON( "/catalog/products/search", {
                search_string: this.term
            },
            function( data, status, xhr ) {
                WarehouseAutocompleteForm.cache[ WarehouseAutocompleteForm.term ] = data;
                response( data );
            });
    },
    scrollToFocusedElement: function(element) {
        $('html, body').animate({
            scrollTop: (element.first().offset().top)
        }, 1200);
    },
    init: function() {


        if ($('#inventoryErrors').find('tbody > tr').length > 0) {
            $('#inventoryErrors').modal('show');
        }

        this.action = this.formContainer.data('action');

        this.formContainer.keydown(function (e) {
            var code = e.which; // recommended to use e.which, it's normalized across browsers
            if (code==13) {
                e.preventDefault();
                return false;
            }
        });

        this.execute();
        this.ajaxFormLoading();
        this.ajaxFormSubmit();
    },
    execute : function() {

        var self = this;

        self.searchContainer.autocomplete({
            minLength: this.minLength,
            delay: this.delay,
            source: function( request, response ) {
                self.ajaxJson(request, response);
            },
            select: function( event, ui ) {

                self.setValueToInput(ui);
                let selectedItem = self.getSelectedItemId();

                if(selectedItem) {
                    let selectedProduct = self.getSelectedProduct(selectedItem);
                    self.openProductPanel(selectedProduct);
                    setTimeout(function () {
                        self.focus(selectedProduct);
                    }, 500);
                }

                return false;
            },
            focus: function (event, ui) {
                event.preventDefault();
                $(this).val(ui.item.name);
            }
        }).data("ui-autocomplete")._renderItem = function (ul, item) {
            ul.addClass('b-warehouse-autocomplete-result__list');
            var newText = self.replaceText(item.name, this.term);
            return self.setAutocompleResult(ul, item, newText);
        };
    },
    ajaxFormLoading: function () {
        $(document).on('click', '.accordion-toggle', function () {
            var brandId = $(this).data('brand');
            var container = $('#products-table-' + brandId);
            if (container.html().length !== 0) {
                return true;
            }

            $.ajax({
                type: 'POST',
                url: '/warehouse/' + WarehouseAutocompleteForm.action + '/get_products',
                data: {brandId: brandId},
                dataType: 'html',
                success : function (response) {
                    container.html(response);
                }
            });
        });
    },
    ajaxFormSubmit: function () {
        var notificationsContainer = $('.warehouse-notifications');
        notificationsContainer.find('button').on('click', function () {
            notificationsContainer.hide();
        });

        $(document).on('click', '.warehouse_submit', function () {
            $.ajax({
                type: 'POST',
                url: '/warehouse/' + WarehouseAutocompleteForm.action + '/store_products',
                data: WarehouseAutocompleteForm.formContainer.serializeArray(),
                dataType: 'json',
                success : function (response) {
                    $('.warehouse-notifications__body').html(response.message);
                    notificationsContainer.addClass('alert-' + response.status).show();

                    if (response.hasOwnProperty("reserveErrors")) {
                        var inventoryErrorsModal = $('#inventoryErrors');
                        inventoryErrorsModal.find('tbody').html(response.reserveErrors);
                        inventoryErrorsModal.modal('show');
                    }
                }
            });
        });
    }
};

export default WarehouseAutocompleteForm;
